export default "__VITE_PUBLIC_ASSET__db6a300c__"